var map = {
	"./facebook.svg": 52541,
	"./instagram.svg": 67408,
	"./linkedin.svg": 88209,
	"./logo-gemfinance.svg": 4504,
	"./logo-latitude.svg": 24545,
	"./twitter.svg": 47522,
	"./xtwitter.svg": 65297,
	"./youtube.svg": 71909
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56441;